'use strict';

var scrollAnimate = require('./scrollAnimate');

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
    $(form).find('.invalid-feedback').hide();
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();

    if (typeof payload === 'object' && payload.fields) {
        var cutomErrorIcon = '<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>';
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find('[name="' + key + '"]')
                    .parent()
                    .children('.invalid-feedback');

                if (feedbackElement.length > 0) {
                    var fieldMsg = Array.isArray(payload.fields[key])
                        ? payload.fields[key].join(' ')
                        : payload.fields[key];
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(cutomErrorIcon + payload.fields[key] + '</span>');
                    }
                    feedbackElement.siblings('.form-control').addClass('is-invalid');
                    feedbackElement.show();
                    // Inject a fresh role="alert" node so NVDA announces exactly once.
                    // When inside a modal dialog NVDA only tracks live regions within
                    // that dialog, so inject there; otherwise inject into body.
                    if (fieldMsg && !window.pmAnnouncePending) {
                        window.pmAnnouncePending = true;
                        setTimeout(function () { window.pmAnnouncePending = null; }, 300);
                        var $dialog = $(formElement).closest('[role="dialog"]');
                        var $parent = $dialog.length ? $dialog : $('body');
                        var $alertEl = $('<div>', { role: 'alert', 'aria-atomic': 'true' })
                            .addClass('sr-only')
                            .css('text-transform', 'none')
                            .text(fieldMsg);
                        $parent.append($alertEl);
                        setTimeout(function () { $alertEl.remove(); }, 1500);
                    }
                }
            }
        });
        if (formElement.closest('.modal').length === 0) {
            scrollAnimate(formElement.find('.is-invalid:first'));
        }
    }
    if (payload && payload.error) {
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');

        form.prepend('<div class="alert alert-danger" role="alert">'
            + payload.error.join('<br/>') + '</div>');
    }
};
